<template>
    <PageWrapper :isLoading="isLoading" hasFilters @submitFilters="setPageNumberAndSendRequest">
        <template #title>گزارش پکیج های مشاوره</template>
        <template #filters>
            <CustomDatePicker class="w-24 filters-width" inputId="dailyStartDate"
                :value="supportListFilters.fromDate" @getSelectedDate="setStartDate" inputLabel="تاریخ شروع بازه"
                inputPlaceholder="1403/06/05">
            </CustomDatePicker>

            <CustomDatePicker class="w-24 filters-width" inputId="dailyEndDate" :value="supportListFilters.toDate"
                @getSelectedDate="setEndDate" inputLabel="تاریخ پایان بازه" inputPlaceholder="1403/06/05">
            </CustomDatePicker>
        </template>
        <BRow
      class="mb-2"
    >
      <BCol cols="12" class="mb-1">
        <hr />
      </BCol>
      <BCol cols="12" md="4">
        <p>
          مبلغ کل فروش پکیج ها:
          <span class="text-success">
            {{ Intl.NumberFormat("en-US").format(totalSale) }}
          </span>
          تومان
        </p>
      </BCol>
      <BCol cols="12" md="4">
        <p>
          تعداد فروش کل پکیج ها:
          <span class="text-success">
            {{ totalUser }}
          </span>
          نفر
        </p>
      </BCol>
    </BRow>

        <CustomTable :pageNumber="supportListFilters.pageNumber" :count="supportListFilters.count"
            :totalCount="totalCount" :tableColumns="tableColumns" :tableItems="supportList" @changePage="changePage">
            
        </CustomTable>
    </PageWrapper>
</template>

<script>
import { BLink, VBTooltip } from "bootstrap-vue";

export default {
    mounted() {
        if (this.computedPageRouteQuery) {
            this.supportListFilters.pageNumber = this.computedPageRouteQuery;
        }

        this.getAllSupportList();
    },

    data() {
        return {
            isLoading: false,
            supportList: null,
            totalCount: null,
            totalSale:null,
            totalUser:null,
            supportListFilters: {
                pageNumber: 1,
                count: 10,
                fromDate: null,
                toDate: null,
            },
            tableColumns: [
            {
                    key: "packageId",
                    label: "شناسه",
                },
                {
                    key: "title",
                    label: "عنوان پکیج",
                },
                {
                    key: "orderCount",
                    label: "تعداد سفارش",
                },
                {
                    key: "userCount",
                    label: "تعداد افراد",
                },
                {
                    key: "priceCount",
                    label: "جمع کل سفارش",
                    formatter: (value) =>
                    value ? `${Intl.NumberFormat("en-US").format(value)} تومان` : "-",
                },

            ],
        };
    },

    methods: {
        setStartDate(date) {
            this.supportListFilters.fromDate = new Date(date).toISOString();

        },
        setEndDate(date) {
            this.supportListFilters.toDate = new Date(date).toISOString();
        },

        setPageNumberAndSendRequest() {
            this.supportListFilters.pageNumber = 1;
            this.setPageNumberQuery(1);
            this.getAllSupportList();
        },

        changePage(pageNumber) {
            this.supportListFilters.pageNumber = pageNumber;
            this.setPageNumberQuery(pageNumber);
            this.getAllSupportList();
        },

        setPageNumberQuery(pageNumber) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    page: pageNumber,
                },
            });
        },

        async getAllSupportList() {
            try {
                this.isLoading = true;

                const _this = this;

                const getAllConsultList = new CounselingPackageReport(_this);
                getAllConsultList.setRequestParamDataObj(_this.supportListFilters);

                await getAllConsultList.fetch((res) => {
                    if (res.isSuccess) {
                        _this.supportList = res.data.data;
                        _this.totalCount = res.data.total;
                        _this.totalSale=res.data.sum
                        _this.totalUser=res.data.sum2
                    }
                });
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },
    },

    computed: {
        computedPageRouteQuery() {
            if (this.$route.query && this.$route.query.page) {
                return this.$route.query.page;
            }
            return null;
        },
    },
    directives: {
        BTooltip: VBTooltip,
    },
    components: {
        PageWrapper,
        CustomTable,
        SearchInput,
        CustomDatePicker,
        BLink,
    },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import { CounselingPackageReport } from "@/libs/Api/Counseling";
</script>